@if (!loading() && form) {
  <div class="flex flex-col gap-2 mt-2 px-3 sm:px-0">
    <div class="flex flex-col gap-1">
      <div class="flex items-center justify-between">
        <span class="text-sm font-semibold uppercase tracking-wide text-primary">
          Artikel
        </span>
        @if (isDefinedNotEmpty($safeNavigationMigration(form?.value?.dimensionen))) {
          <button
            type="button"
            class="soft-button link p-0!"
            (click)="openFormularModal()"
          >
            Formel ändern
          </button>
        }
      </div>
      @if (form?.value?.artikel) {
        <div class="flex flex-col border border-slate-300 p-3 bg-surface-secondary">
          <span class="text-sm text-light font-medium">
            {{ form?.value?.artikel?.nummer }}
          </span>
          @if (form?.value?.artikel?.artbez1) {
            <span class="text-lg font-semibold">{{ form?.value?.artikel?.artbez1 }}</span>
          }
          @if (form?.value?.artikel?.artbez2) {
            <span class="text-base text-light">{{ form?.value?.artikel?.artbez2 }}</span>
          }
          @if (stock(); as stockValue) {
            <span class="text-sm font-semibold text-light mt-1">
              Lagerstand:
              <span [class.text-danger]="stockValue.amount < 0">
                {{ stockValue.amount | number: '1.2-2' }}
              </span>
              {{ stockValue.unit ?? '' }}
              @if (stockValue.dispo !== null && stockValue.dispo !== undefined) {
                <span class="ml-1">
                  · Dispo:
                  <span [class.text-danger]="stockValue.dispo < 0">
                    {{ stockValue.dispo | number: '1.2-2' }}
                  </span>
                  {{ stockValue.unit ?? '' }}
                </span>
              }
            </span>
          }
        </div>
      }
    </div>
  </div>

  <div class="flex items-center w-full justify-end mt-3"></div>

  <form [formGroup]="form" class="mt-3 px-3 sm:px-0">
    <table class="table-fixed w-full border-collapse border border-slate-400">
      <thead>
        <tr class="h-10 bg-surface-tertiary">
          <th class="w-2/12 border min-w-12 border-slate-300 text-right px-2">
            {{ form.value?.summeEinheit?.einheit?.arteh }}
          </th>
          <th class="w-5/12 border border-slate-300 text-left px-2">Einheit</th>
          <th class="w-5/12 border border-slate-300 text-right px-2">Menge</th>
        </tr>
      </thead>
      <tbody formArrayName="einheiten">
        @for (
          einheit of $any(form.controls['einheiten']).controls;
          track einheit;
          let i = $index
        ) {
          <tr
            class="h-10"
            [ngClass]="
              einheit.value?.editable === false ? 'bg-readonly' : 'bg-surface-secondary'
            "
          >
            <ng-container [formGroupName]="i">
              <td
                class="border border-slate-300 text-right px-2 min-w-12"
                [ngClass]="{
                  'bg-yellow-100': einheit.controls['einheit']?.value?.kzausgabe !== 'N',
                }"
              >
                {{ einheit.controls['einheit']?.value?.faktor ?? 1 | number: '1.3-3' }}
              </td>
              <td
                class="border border-slate-300 text-left px-2"
                [ngClass]="{
                  'bg-yellow-100': einheit.controls['einheit']?.value?.kzausgabe !== 'N',
                }"
              >
                {{ einheit.controls['einheit']?.value?.arteh }}
              </td>
              <td
                class="border border-slate-300"
                [ngClass]="
                  einheit.value?.editable === false ? 'bg-readonly' : 'bg-surface'
                "
              >
                <soft-number-input
                  changeTrigger="blur"
                  placeholder=" "
                  format="1.3-3"
                  class="appearance-none border-none text-base"
                  formControlName="menge"
                  [readonly]="einheit.value?.editable === false"
                  [softVirtualKeyboardEnabled]="true"
                  textAlign="right"
                ></soft-number-input>
              </td>
            </ng-container>
          </tr>
        }
      </tbody>
      <tfoot>
        <!-- SUMMENZEILE -->
        <tr formGroupName="summeEinheit" class="h-10 bg-blue-800/15">
          <td class="border border-slate-300 text-right px-2 font-semibold min-w-12">
            Gesamt
          </td>
          <td class="border border-slate-300 text-left px-2 font-semibold">
            {{ form.value?.summeEinheit?.einheit?.arteh }}
          </td>
          <td class="border border-slate-300 text-right px-2 font-semibold">
            {{ form.value?.summeEinheit?.menge ?? 1 | number: '1.3-3' }}
          </td>
        </tr>

        <!-- DIMENSIONS -->
        <ng-container formGroupName="dimensionen">
          @if (form?.value?.dimensionen; as dimensionen) {
            @if (dimensionen?.tiefe !== null && dimensionen?.tiefe !== undefined) {
              <tr class="h-10 bg-purple-800/15">
                <td class="border border-slate-300 text-right px-2 min-w-12">
                  {{ dimensionen?.tiefeBez ?? '' }}
                </td>
                <td class="border border-slate-300 text-left px-2">L</td>
                <td class="border border-slate-300 bg-surface">
                  <soft-number-input
                    changeTrigger="blur"
                    placeholder=" "
                    format="1.3-3"
                    class="appearance-none border-none text-base"
                    formControlName="tiefe"
                    [softVirtualKeyboardEnabled]="true"
                    textAlign="right"
                  ></soft-number-input>
                </td>
              </tr>
            }

            @if (dimensionen?.breite !== null && dimensionen?.breite !== undefined) {
              <tr class="h-10 bg-purple-800/15">
                <td class="border border-slate-300 text-right px-2 min-w-12">
                  {{ dimensionen?.breiteBez ?? '' }}
                </td>
                <td class="border border-slate-300 text-left px-2">B</td>
                <td class="border border-slate-300 bg-surface">
                  <soft-number-input
                    changeTrigger="blur"
                    placeholder=" "
                    format="1.3-3"
                    class="appearance-none border-none text-base"
                    formControlName="breite"
                    [softVirtualKeyboardEnabled]="true"
                    textAlign="right"
                  />
                </td>
              </tr>
            }

            @if (dimensionen?.hoehe !== null && dimensionen?.hoehe !== undefined) {
              <tr class="h-10 bg-purple-800/15">
                <td class="border border-slate-300 text-right px-2 min-w-12">
                  {{ dimensionen?.hoeheBez ?? '' }}
                </td>
                <td class="border border-slate-300 text-left px-2">H</td>
                <td class="border border-slate-300 bg-surface">
                  <soft-number-input
                    changeTrigger="blur"
                    placeholder=" "
                    format="1.3-3"
                    class="appearance-none border-none text-base"
                    formControlName="hoehe"
                    [softVirtualKeyboardEnabled]="true"
                    textAlign="right"
                  />
                </td>
              </tr>
            }
          }
        </ng-container>
      </tfoot>
    </table>
  </form>
} @else if (loading()) {
  <!-- LOADING (SKELETON) -->
  <div class="flex flex-col w-full gap-2 mt-2">
    <div class="w-1/12 h-6 skeleton rounded mt-1"></div>
    <div class="w-full h-20 skeleton"></div>
  </div>
  <div class="flex flex-col mt-2" *softRepeat="3">
    <div class="flex gap-4 w-full">
      <div class="w-2/12 h-10 skeleton text-right"></div>
      <div class="w-5/12 h-10 skeleton text-left"></div>
      <div class="w-5/12 h-10 skeleton text-right"></div>
    </div>
  </div>
} @else {
  <!-- ERROR -->
  <div class="flex flex-col w-full gap-3 mt-3">
    <div>Beim Laden ist ein Fehler aufgetreten. Möchten Sie es erneut versuchen?</div>
    <button
      type="button"
      class="soft-button primary h-16 text-center w-full"
      (click)="retry()"
    >
      Erneut versuchen
    </button>
  </div>
}

<div class="flex items-center mt-4 gap-3">
  <button
    type="button"
    class="soft-button w-full h-16 text-center secondary"
    (click)="resolve(null)"
  >
    Abbrechen
  </button>
  @if (form) {
    <button
      type="button"
      [disabled]="!form || loading() || form.invalid"
      (click)="submit()"
      class="soft-button w-full h-16 text-center primary"
    >
      Übernehmen
    </button>
  }
</div>
